// extracted by mini-css-extract-plugin
module.exports = {"form":"style_form__1G-V9","customPlaceholder":"style_customPlaceholder__2PS-a"};